var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3762 49.8753L0.125 26.624V31.374C0.125 32.6328 0.62375 33.844 1.52625 34.7228L20.0275 53.224C21.88 55.0765 24.8962 55.0765 26.7488 53.224L41.4975 38.4753C43.35 36.6228 43.35 33.6065 41.4975 31.754L23.3762 49.8753Z",
    fill: "#273135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0275 41.3488C20.9538 42.275 22.165 42.75 23.3763 42.75C24.5875 42.75 25.7988 42.275 26.725 41.3488L41.4738 26.6C43.3263 24.7475 43.3263 21.7312 41.4738 19.8787L22.9725 1.3775C22.0938 0.49875 20.8825 0 19.6238 0H4.875C2.2625 0 0.125 2.1375 0.125 4.75V19.4988C0.125 20.7575 0.62375 21.9688 1.52625 22.8475L20.0275 41.3488ZM4.875 4.75H19.6238L38.125 23.2512L23.3763 38L4.875 19.4988V4.75Z",
    fill: "#273135"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 13.0625C11.8583 13.0625 13.1875 11.7333 13.1875 10.0938C13.1875 8.45415 11.8583 7.125 10.2188 7.125C8.5792 7.125 7.25 8.45415 7.25 10.0938C7.25 11.7333 8.5792 13.0625 10.2188 13.0625Z",
    fill: "#273135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.755a6e83e4dd7cab4fa7e8d46f35e1c7.svg";
export { ForwardRef as ReactComponent };